import dynamic from 'next/dynamic';
import React from 'react';
import { LayoutWithUserNav } from '@members/layout/containers';

const Overview = dynamic(() => import('@members/pg-overview/Overview'), {
  ssr: false,
});

export default function OverviewPage() {
  return (
    <LayoutWithUserNav>
      <Overview />
    </LayoutWithUserNav>
  );
}
